import api from './api';
import { AuthResponse, LoginRequest, RegisterRequest, User } from '../types/user.types';

export const authService = {
    // Traditional Login
    login: async (credentials: LoginRequest): Promise<AuthResponse> => {
        const response = await api.post<AuthResponse>('/auth/login', credentials);

        // Store token and user in localStorage
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));

        return response.data;
    },

    // Logout
    logout: (): void => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('barberCurrentDailyDay');
        sessionStorage.removeItem('barberCurrentWeekStart');
        window.location.href = '/login';
    },

    // Get current user from localStorage
    getCurrentUser: (): User | null => {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                return JSON.parse(userStr);
            } catch {
                return null;
            }
        }
        return null;
    },

    // Check if user is authenticated
    isAuthenticated: (): boolean => {
        return !!localStorage.getItem('token');
    },

    // Check if user has specific role
    hasRole: (role: string): boolean => {
        const user = authService.getCurrentUser();
        return user?.roles?.includes(role) || false;
    },

    // Register new client
    register: async (data: RegisterRequest): Promise<AuthResponse> => {
        const response = await api.post<AuthResponse>('/auth/register', data);

        // Note: We no longer auto-login here because the user needs to verify their email first.
        // We just return the response which contains the confirmation message.

        return response.data;
    },

    // Verify email with token
    verifyEmail: async (token: string): Promise<any> => {
        const response = await api.post(`/auth/verify-email?token=${token}`);
        return response.data;
    },

    // Resend verification email
    resendVerification: async (email: string): Promise<any> => {
        const response = await api.post(`/auth/resend-verification?email=${email}`);
        return response.data;
    },

    // Get auth token
    getToken: (): string | null => {
        return localStorage.getItem('token');
    },

    // Request password reset
    forgotPassword: async (email: string): Promise<any> => {
        const response = await api.post('/auth/forgot-password', { email });
        return response.data;
    },

    // Reset password
    resetPassword: async (token: string, password: string): Promise<any> => {
        const response = await api.post('/auth/reset-password', { token, password });
        return response.data;
    },
};
